'use strict';

var Reflux = require('reflux');

/* Actions */
var TranslationEditorActions = require('actions/translation-editor');

var TranslationEditorStore = Reflux.createStore({

  listenables: [TranslationEditorActions],

  init: function init() {
    var store = this;

    store.open = false;
    store.translations = [];
    store.groupName = null;
    store.baseTranslationKey = null;
    store.callback = function () {};
    store.value = {};
    store.selectedTranslation = null;
  },

  getInitialState: function getInitialState() {
    var store = this;
    var translations = store.translations;

    return translations;
  },

  onOpenEditor: function onOpenEditor(groupName, baseTranslationKey, translations, value, callback) {
    var store = this;

    store.open = true;
    store.groupName = groupName;
    store.baseTranslationKey = baseTranslationKey;
    store.translations = translations;
    store.callback = callback;
    store.value = {};
    store.selectedTranslation = translations.length ? translations[0] : null;

    for (var p in value) {
      store.value[p] = value[p];
    }

    store.trigger(store.translations);
  },

  onSelectTranslation: function onSelectTranslation(translation) {
    var store = this;

    store.selectedTranslation = translation;

    store.trigger(store.translations);
  },

  onUpdateTranslation: function onUpdateTranslation(newValue) {
    var store = this;

    if (store.selectedTranslation) {
      store.value[store.selectedTranslation] = newValue;

      store.trigger(store.translations);
    }
  },

  onSave: function onSave(translations) {
    var store = this;

    store.callback(store.value);

    store.onCancel();
  },

  onCancel: function onCancel() {
    var store = this;

    store.open = false;
    store.translations = [];
    store.groupName = null;
    store.baseTranslationKey = null;
    store.selectedTranslation = null;

    store.callback = function () {};
    store.value = {};

    store.trigger(store.translations);
  }
});

module.exports = TranslationEditorStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/translation-editor.js
 **/